import { ReflectionQuestion, ReflectionQuestionType } from "@webapp/reflections/models/reflections.models";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";

export const generateCustomReflectionQuestion = (params?: { text: string }): ReflectionQuestion<ReflectionQuestionType> => ({
  id: uuidv4(),
  text: params?.text || "Custom question",
  isEnabled: true,
  isDefault: false,
  createdAt: dayjs.utc().toISOString(),
  type: ReflectionQuestionType.textArea,
});
